import { Action } from '@ngrx/store';
import { StoryblokGlobalContent } from '../../models/storyblok-global-content.model';

export enum StoryblokGlobalContentActionTypes {
  LOAD_STORYBLOK_GLOBAL_CONTENT = '[Storyblok Global Content] Storyblok Global Content Load',
  LOAD_STORYBLOK_GLOBAL_CONTENT_SUCCESS = '[Storyblok Global Content] Storyblok Global Content Success',
  LOAD_STORYBLOK_GLOBAL_CONTENT_FAILURE = '[Storyblok Global Content] Storyblok Global Content Failed',
}

export class LoadStoryblokGlobalContent implements Action {
  type = StoryblokGlobalContentActionTypes.LOAD_STORYBLOK_GLOBAL_CONTENT;
}

export class LoadStoryblokGlobalContentSuccess implements Action {
  type = StoryblokGlobalContentActionTypes.LOAD_STORYBLOK_GLOBAL_CONTENT_SUCCESS;

  constructor(public payload: StoryblokGlobalContent) {}
}

export class LoadStoryblokGlobalContentFailure implements Action {
  type = StoryblokGlobalContentActionTypes.LOAD_STORYBLOK_GLOBAL_CONTENT_FAILURE;

  constructor(public payload: string) {}
}

export type StoryblokGlobalContentActionsUnion =
  | LoadStoryblokGlobalContent
  | LoadStoryblokGlobalContentSuccess
  | LoadStoryblokGlobalContentFailure;
